export default __webpack_public_path__ + "static/media/isip.38374f21.svg";